import { UploadedFile } from "./uploaded-file.model";

export enum ObsessedEngineeringOrderType {
	Picked = 'Picked',
	OutTheDoor = 'Out the Door',
}

export enum ObsessedEngineeringOrderStatus {
	Draft = 'Draft',
	Released = 'Released',
	Hold = 'Hold',
	ReadyToShip = 'Ready To Ship',
	Complete = 'Complete',
	Canceled = 'Canceled',
}

export interface ObsessedEngineeringOrder {
	id: string;
	orderNumber: string;
	type: ObsessedEngineeringOrderType;
	customerPurchaseOrderNumber: string;
	status: ObsessedEngineeringOrderStatus;
	/** First successful release; retained when the status changes later. */
	releasedOn: Date | null;
	dueDate: Date;
	notes: string;
	createdOn: Date;
	createdById: string;
	updatedOn: Date;
	updatedById: string;
	files: UploadedFile[];
	changeLog: ObsessedEngineeringOrderChangeLog[];
}

export interface ObsessedEngineeringOrderChangeLog {
	id: string;
	createdOn: Date;
	createdById: string;
	text: string;
}
